import { useState, useEffect, useRef } from "react";

/*
  LagnaSetu Admin Panel — React component.
  Drop this into your React frontend (e.g. src/pages/AdminPanel.jsx) and route to it.

  Every API path below has NO /api prefix. The api() helper does NOT
  add a prefix — The api() helper does NOT add a prefix. When served from the same
  domain as the backend (nginx proxies "/" to FastAPI on :8013), leave the API base
  URL field empty. Backend routers must be mounted WITHOUT a prefix.
  For local dev (vite on :5173 -> backend on :8013), set the API base to
  "http://localhost:8013" on the login screen.

  Requires the backend routers to be mounted with prefix="/api".
*/

const CSS = `
.lagna-admin{
  --ocean:#1B7FBD; --ocean-deep:#0E5C8C; --peacock:#0E8C7F; --mint:#6FE3CF;
  --sky:#7FD4F5; --base:#FAFBFD; --ink:#1d2b36; --ink-soft:#5a6b7b;
  --frost:rgba(255,255,255,.62); --frost-border:rgba(255,255,255,.8);
  font-family:'Inter',system-ui,sans-serif;color:var(--ink);min-height:100vh;
  background:
    radial-gradient(900px 500px at 15% -10%, #e8f4fb 0%, transparent 60%),
    radial-gradient(800px 600px at 110% 30%, #e6f7f3 0%, transparent 55%),
    var(--base);
}
.lagna-admin *{margin:0;padding:0;box-sizing:border-box}
.lagna-admin h1,.lagna-admin h2,.lagna-admin h3,.lagna-admin .brand{font-family:'Sora',sans-serif}
.lagna-admin .glass{
  background:var(--frost);backdrop-filter:blur(18px);-webkit-backdrop-filter:blur(18px);
  border:1.2px solid var(--frost-border);border-radius:22px;
  box-shadow:0 8px 28px rgba(20,40,60,.06);
}
.lagna-admin .login{display:flex;align-items:center;justify-content:center;min-height:100vh}
.lagna-admin .login .glass{padding:44px;width:380px}
.lagna-admin .brand{font-size:28px;font-weight:800;letter-spacing:-.5px;
  background:linear-gradient(90deg,var(--ocean),var(--peacock));
  -webkit-background-clip:text;background-clip:text;color:transparent}
.lagna-admin .brand small{display:block;font-size:12px;color:var(--ink-soft);
  -webkit-text-fill-color:var(--ink-soft);font-family:'Inter';font-weight:500;
  letter-spacing:.12em;text-transform:uppercase;margin-top:4px}
.lagna-admin label{display:block;font-size:12.5px;font-weight:600;color:var(--ink-soft);margin:16px 0 6px}
.lagna-admin input,.lagna-admin select,.lagna-admin textarea{
  width:100%;padding:12px 14px;border-radius:14px;font:inherit;font-size:14px;
  border:1.2px solid rgba(255,255,255,.9);background:rgba(255,255,255,.75);outline:none;
}
.lagna-admin input:focus,.lagna-admin select:focus{border-color:var(--ocean)}
.lagna-admin button{
  font:inherit;font-weight:600;border:none;cursor:pointer;border-radius:14px;
  padding:12px 18px;background:linear-gradient(90deg,var(--ocean),var(--ocean-deep));
  color:#fff;transition:transform .12s ease, box-shadow .12s;
}
.lagna-admin button:hover{transform:translateY(-1px);box-shadow:0 6px 18px rgba(27,127,189,.3)}
.lagna-admin button.ghost{background:rgba(255,255,255,.7);color:var(--ocean-deep);
  border:1.2px solid rgba(27,127,189,.25)}
.lagna-admin button.danger{background:linear-gradient(90deg,#d65a5a,#b13e3e)}
.lagna-admin .full{width:100%;margin-top:22px}
.lagna-admin .err{color:#b13e3e;font-size:13px;margin-top:12px;min-height:18px}
.lagna-admin .app{display:grid;grid-template-columns:230px 1fr;gap:22px;padding:22px;max-width:1500px;margin:auto}
.lagna-admin nav.glass{padding:22px 14px;height:calc(100vh - 44px);position:sticky;top:22px;overflow-y:auto}
.lagna-admin nav .brand{font-size:20px;padding:0 10px 18px}
.lagna-admin nav a{
  display:flex;gap:10px;align-items:center;padding:10px 12px;border-radius:13px;
  color:var(--ink-soft);text-decoration:none;font-size:13.5px;font-weight:600;margin-bottom:3px;cursor:pointer;
}
.lagna-admin nav a.active,.lagna-admin nav a:hover{background:rgba(27,127,189,.1);color:var(--ocean-deep)}
.lagna-admin main{min-width:0}
.lagna-admin .section>h2{font-size:22px;letter-spacing:-.4px;margin-bottom:16px}
.lagna-admin .tiles{display:grid;grid-template-columns:repeat(auto-fit,minmax(180px,1fr));gap:14px;margin-bottom:22px}
.lagna-admin .tile{padding:20px}
.lagna-admin .tile .num{font-family:'Sora';font-size:30px;font-weight:800;letter-spacing:-1px;
  background:linear-gradient(90deg,var(--ocean),var(--peacock));
  -webkit-background-clip:text;background-clip:text;color:transparent}
.lagna-admin .tile .lbl{font-size:12px;color:var(--ink-soft);font-weight:600;letter-spacing:.06em;text-transform:uppercase;margin-top:4px}
.lagna-admin .card{padding:20px;margin-bottom:18px}
.lagna-admin .row{display:flex;gap:10px;flex-wrap:wrap;align-items:end}
.lagna-admin .row>div{flex:1;min-width:130px}
.lagna-admin table{width:100%;border-collapse:collapse;font-size:13px;margin-top:14px}
.lagna-admin th{font-size:11px;text-transform:uppercase;letter-spacing:.08em;color:var(--ink-soft);
  text-align:left;padding:8px 10px;border-bottom:1.2px solid rgba(27,127,189,.15)}
.lagna-admin td{padding:9px 10px;border-bottom:1px solid rgba(20,40,60,.05);vertical-align:top}
.lagna-admin tr:hover td{background:rgba(255,255,255,.55)}
.lagna-admin .pill{display:inline-block;padding:2px 9px;border-radius:99px;font-size:11px;font-weight:700}
.lagna-admin .pill.ok{background:rgba(14,140,127,.13);color:var(--peacock)}
.lagna-admin .pill.bad{background:rgba(214,90,90,.13);color:#b13e3e}
.lagna-admin .pill.mid{background:rgba(27,127,189,.13);color:var(--ocean-deep)}
.lagna-admin td button{padding:5px 11px;font-size:12px;border-radius:9px;margin-right:5px}
.lagna-admin .muted{color:var(--ink-soft);font-size:12.5px}
.lagna-admin pre{white-space:pre-wrap;font-size:11.5px;background:rgba(255,255,255,.6);padding:8px;border-radius:8px}
.lagna-admin hr{border:none;border-top:1px solid rgba(20,40,60,.08);margin:12px 0}
@media(max-width:900px){.lagna-admin .app{grid-template-columns:1fr}.lagna-admin nav.glass{position:static;height:auto}}
`;

const inr = (n) => Number(n || 0).toLocaleString("en-IN");
const dt = (s) =>
  s
    ? new Date(s).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" })
    : "—";

const Pill = ({ kind, children }) => <span className={"pill " + kind}>{children}</span>;

function Table({ rows, cols, actions }) {
  if (!rows || !rows.length)
    return <p className="muted" style={{ marginTop: 12 }}>Nothing here yet.</p>;
  return (
    <table>
      <tbody>
        <tr>
          {cols.map((c, i) => <th key={i}>{c.label}</th>)}
          {actions && <th></th>}
        </tr>
        {rows.map((r, ri) => (
          <tr key={ri}>
            {cols.map((c, ci) => (
              <td key={ci}>{c.fn ? c.fn(r) : r[c.key] ?? "—"}</td>
            ))}
            {actions && <td>{actions(r)}</td>}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

const NAV = [
  ["dash", "📊 Dashboard"], ["users", "👥 Users"], ["pricing", "🏷️ Pricing"],
  ["coupons", "🎟️ Coupons"], ["referrals", "🤝 Referrals"], ["revenue", "💰 Revenue"],
  ["market", "🏪 Marketplace"], ["keywords", "🚫 Keywords"], ["banners", "🖼️ Banners"],
  ["payments", "💳 Payments"], ["featured", "✨ Featured"], ["rankings", "🏆 Rankings"],
  ["errors", "🐞 Crashes"], ["faqs", "❓ FAQs"], ["audit", "📜 Audit log"],
];

export default function AdminPanel() {
  const [token, setToken] = useState(() => localStorage.getItem("bandhan_token") || "");
  const [apiBase, setApiBase] = useState(() => localStorage.getItem("bandhan_api") || "");
  const [loggedIn, setLoggedIn] = useState(() => !!localStorage.getItem("bandhan_token"));
  const [section, setSection] = useState("dash");
  const [loginErr, setLoginErr] = useState("");

  // input registry — mirrors the original $('id') pattern with refs
  const R = useRef({});
  const reg = (id) => (el) => { if (el) R.current[id] = el; };
  const val = (id) => R.current[id]?.value ?? "";
  const setVal = (id, v) => { if (R.current[id]) R.current[id].value = v; };

  // data states
  const [dash, setDash] = useState(null);
  const [users, setUsers] = useState([]);
  const [pricing, setPricing] = useState([]);
  const [coupons, setCoupons] = useState([]);
  const [couponLogs, setCouponLogs] = useState([]);
  const [referrals, setReferrals] = useState([]);
  const [revenue, setRevenue] = useState(null);
  const [revFilter, setRevFilter] = useState("");
  const [marketCats, setMarketCats] = useState([]);
  const [marketBiz, setMarketBiz] = useState([]);
  const [keywords, setKeywords] = useState([]);
  const [violations, setViolations] = useState([]);
  const [banners, setBanners] = useState([]);
  const [payments, setPayments] = useState([]);
  const [featured, setFeatured] = useState([]);
  const [rankings, setRankings] = useState([]);
  const [errors, setErrors] = useState([]);
  const [faqs, setFaqs] = useState([]);
  const [audit, setAudit] = useState([]);

  // load Google fonts once
  useEffect(() => {
    if (document.getElementById("lagna-fonts")) return;
    const l = document.createElement("link");
    l.id = "lagna-fonts";
    l.rel = "stylesheet";
    l.href =
      "https://fonts.googleapis.com/css2?family=Sora:wght@400;600;700;800&family=Inter:wght@400;500;600&display=swap";
    document.head.appendChild(l);
  }, []);

  // NOTE: api() adds no prefix. Paths are sent as-is (e.g. "/admin/stats", "/login").
  async function api(path, opts = {}) {
    const res = await fetch((apiBase || "") + path, {
      ...opts,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        ...(opts.headers || {}),
      },
    });
    if (res.status === 401 || res.status === 403) { logout(); throw new Error("auth"); }
    if (!res.ok) {
      const body = await res.json().catch(() => ({}));
      throw new Error(typeof body.detail === "string" ? body.detail : "Request failed");
    }
    return res.json();
  }

  async function doLogin() {
    const base = val("lApi").replace(/\/$/, "");
    setLoginErr("");
    try {
      const res = await fetch(base + "/api/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: val("lEmail"), password: val("lPass") }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || "Login failed");
      if (data.role !== "admin") throw new Error("This account is not an admin");
      localStorage.setItem("bandhan_token", data.token);
      localStorage.setItem("bandhan_api", base);
      setToken(data.token);
      setApiBase(base);
      setLoggedIn(true);
      setSection("dash");
    } catch (e) {
      setLoginErr(e.message);
    }
  }

  function logout() {
    localStorage.removeItem("bandhan_token");
    setToken("");
    setLoggedIn(false);
  }

  // ---------- loaders ----------
  async function loadDash() { setDash(await api("/api/admin/stats")); }
  async function loadUsers() {
    const q = val("uQ").trim();
    setUsers(await api("/api/admin/users" + (q ? "?q=" + encodeURIComponent(q) : "")));
  }
  async function loadPricing() { setPricing(await api("/api/admin/pricing")); }
  async function loadCoupons() {
    setCoupons(await api("/api/admin/coupons"));
    setCouponLogs(await api("/api/admin/coupons/logs"));
  }
  async function loadReferrals() { setReferrals(await api("/api/admin/referrals/logs")); }
  async function loadRevenue() {
    setRevenue(await api("/api/admin/revenue/summary"));
  }
  async function loadKeywords() {
    setKeywords(await api("/api/admin/keywords"));
    setViolations(await api("/api/admin/violations"));
  }
  async function loadBanners() { setBanners(await api("/api/admin/banners")); }
  async function loadPayments() { setPayments(await api("/api/admin/payments")); }
  async function loadFeatured() { setFeatured(await api("/api/admin/featured/logs")); }
  async function loadRankings() { setRankings(await api("/api/admin/rankings")); }
  async function loadErrors() { setErrors(await api("/api/admin/errors")); }
  async function loadFaqs() { setFaqs(await api("/api/admin/faqs")); }
  async function loadAudit() { setAudit(await api("/api/admin/audit")); }
  async function loadMarket() {
    const cats = await api("/api/admin/marketplace/categories");
    setMarketCats(cats);
  }

  const loaders = {
    dash: loadDash, users: loadUsers, pricing: loadPricing, coupons: loadCoupons,
    referrals: loadReferrals, revenue: loadRevenue, market: loadMarket,
    keywords: loadKeywords, banners: loadBanners, payments: loadPayments,
    featured: loadFeatured, rankings: loadRankings, errors: loadErrors,
    faqs: loadFaqs, audit: loadAudit,
  };

  useEffect(() => {
    if (!loggedIn) return;
    loaders[section]?.().catch((e) => e.message !== "auth" && window.alert(e.message));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [section, loggedIn]);

  // ---------- actions ----------
  const guard = (fn) => fn().catch((e) => e.message !== "auth" && window.alert(e.message));

  async function banUser(id) {
    const reason = window.prompt("Ban reason?", "Manual admin ban");
    if (reason === null) return;
    await api(`/api/admin/users/${id}/ban?hours=48&reason=` + encodeURIComponent(reason), { method: "PUT" });
    loadUsers();
  }
  async function setPrice() {
    await api("/api/admin/pricing", {
      method: "PUT",
      body: JSON.stringify({ key: val("pKey"), amount: Math.round(+val("pAmt") * 100), label: val("pLbl") }),
    });
    loadPricing();
  }
  async function createCoupon() {
    const type = val("cType");
    let value = +val("cVal");
    if (type === "flat") value = Math.round(value * 100);
    await api("/api/admin/coupons", {
      method: "POST",
      body: JSON.stringify({ code: val("cCode"), discount_type: type, value, max_uses: +val("cMax") }),
    });
    setVal("cCode", "");
    loadCoupons();
  }
  async function addKeyword() {
    await api("/api/admin/keywords", { method: "POST", body: JSON.stringify({ keyword: val("kWord") }) });
    setVal("kWord", "");
    loadKeywords();
  }
  async function createBanner() {
    await api("/api/admin/banners", {
      method: "POST",
      body: JSON.stringify({ image_url: val("bImg"), target_url: val("bUrl"), position: +val("bPos") }),
    });
    loadBanners();
  }
  async function createFaq() {
    await api("/api/admin/faqs", { method: "POST", body: JSON.stringify({ question: val("fQ"), answer: val("fA") }) });
    setVal("fQ", ""); setVal("fA", "");
    loadFaqs();
  }
  async function loadRevenueFilter() {
    const days = val("revDays") || 7;
    const purpose = val("revPurpose");
    let url = `/api/admin/revenue/filter?days=${days}`;
    if (purpose) url += `&purpose=${purpose}`;
    const r = await api(url);
    if (purpose) {
      setRevFilter(`₹${inr(r.total_rupees)} from ${purpose.replace("_", " ")} in the last ${r.days} days.`);
    } else {
      const bs = Object.entries(r.by_source)
        .map(([k, v]) => `${k.replace("_", " ")}: ₹${inr(v)}`)
        .join("  •  ");
      setRevFilter(`Total ₹${inr(r.total_rupees)} in last ${r.days} days (${bs})`);
    }
  }
  async function addMarketCategory() {
    const name = val("mcName").trim();
    if (!name) return window.alert("Enter a category name");
    await api("/api/admin/marketplace/categories", {
      method: "POST",
      body: JSON.stringify({
        name, icon: val("mcIcon").trim() || null,
        sort_order: parseInt(val("mcSort") || "0"), is_active: true,
      }),
    });
    setVal("mcName", ""); setVal("mcIcon", "");
    loadMarket();
  }
  async function delMarketCategory(id) {
    if (!window.confirm("Delete this category?")) return;
    await api("/api/admin/marketplace/categories/" + id, { method: "DELETE" });
    loadMarket();
  }
  async function loadMarketBusinesses() {
    const cat = val("mbCat");
    const city = val("mbCity").trim();
    let url = "/api/admin/marketplace/businesses?";
    if (city) url += "city=" + encodeURIComponent(city) + "&";
    if (cat) url += "category_id=" + cat;
    setMarketBiz(await api(url));
  }
  async function addMarketBusiness() {
    const body = {
      category_id: parseInt(val("mbCat")),
      city: val("mbCity").trim(),
      name: val("bName").trim(),
      contact_number: val("bPhone").trim() || null,
      email: val("bEmail").trim() || null,
      rating: parseFloat(val("bRating") || "0"),
      total_projects: parseInt(val("bProjects") || "0"),
      latitude: parseFloat(val("bLat")) || null,
      longitude: parseFloat(val("bLng")) || null,
      address: val("bAddr").trim() || null,
      image1: val("bImg1").trim() || null,
      image2: val("bImg2").trim() || null,
      image3: val("bImg3").trim() || null,
      is_active: true,
    };
    if (!body.city || !body.name) return window.alert("City and business name are required");
    try {
      await api("/api/admin/marketplace/businesses", { method: "POST", body: JSON.stringify(body) });
      ["bName", "bPhone", "bEmail", "bRating", "bProjects", "bLat", "bLng", "bAddr", "bImg1", "bImg2", "bImg3"]
        .forEach((id) => setVal(id, ""));
      loadMarketBusinesses();
    } catch (e) {
      window.alert("Could not add (max 5 per city+category reached?)");
    }
  }
  async function delMarketBusiness(id) {
    if (!window.confirm("Delete this business?")) return;
    await api("/api/admin/marketplace/businesses/" + id, { method: "DELETE" });
    loadMarketBusinesses();
  }

  // ---------- login screen ----------
  if (!loggedIn) {
    return (
      <div className="lagna-admin">
        <style>{CSS}</style>
        <div className="login">
          <div className="glass">
            <div className="brand">Bandhan<small>Admin Console</small></div>
            <label>Email</label>
            <input ref={reg("lEmail")} type="email" autoComplete="username" />
            <label>Password</label>
            <input ref={reg("lPass")} type="password" autoComplete="current-password"
                   onKeyDown={(e) => e.key === "Enter" && doLogin()} />
            <label>API base URL</label>
            <input ref={reg("lApi")} defaultValue={apiBase}
                   placeholder="(empty = same domain)" />
            <button className="full" onClick={doLogin}>Sign in</button>
            <div className="err">{loginErr}</div>
          </div>
        </div>
      </div>
    );
  }

  // ---------- app shell ----------
  return (
    <div className="lagna-admin">
      <style>{CSS}</style>
      <div className="app">
        <nav className="glass">
          <div className="brand">LagnaSetu</div>
          {NAV.map(([s, label]) => (
            <a key={s} className={section === s ? "active" : ""} onClick={() => setSection(s)}>{label}</a>
          ))}
          <a style={{ marginTop: 14, color: "#b13e3e" }} onClick={logout}>↩ Sign out</a>
        </nav>

        <main>
          {section === "dash" && (
            <div className="section">
              <h2>Dashboard</h2>
              <div className="tiles">
                {dash &&
                  [
                    ["Total users", dash.total_users],
                    ["Signups 24h", dash.signups_24h],
                    ["Revenue ₹", inr(dash.revenue_paise / 100)],
                    ["Paid orders", dash.payments_success],
                    ["Violations", dash.open_violations],
                    ["Crashes 7d", dash.crashes_7d],
                  ].map(([l, n], i) => (
                    <div className="glass tile" key={i}>
                      <div className="num">{n}</div>
                      <div className="lbl">{l}</div>
                    </div>
                  ))}
              </div>
              <div className="glass card">
                <span className="muted">Revenue &amp; violations update live from the API. Crash count covers the last 7 days.</span>
              </div>
            </div>
          )}

          {section === "users" && (
            <div className="section">
              <h2>Users</h2>
              <div className="glass card">
                <div className="row">
                  <div><label>Search name / email / phone</label><input ref={reg("uQ")} /></div>
                  <button onClick={() => guard(loadUsers)}>Search</button>
                </div>
                <Table rows={users}
                  cols={[
                    { label: "ID", key: "id" }, { label: "Name", key: "full_name" },
                    { label: "Email", key: "email" }, { label: "Phone", key: "phone" },
                    { label: "Role", key: "role" },
                    { label: "Status", fn: (r) => r.is_deleted ? <Pill kind="bad">deleted</Pill>
                        : (r.is_banned || r.banned_until) ? <Pill kind="bad">banned</Pill> : <Pill kind="ok">active</Pill> },
                    { label: "Joined", fn: (r) => dt(r.created_at) },
                  ]}
                  actions={(r) => (
                    <>
                      <button className="ghost" onClick={() => guard(() => banUser(r.id))}>Ban 48h</button>
                      <button className="ghost" onClick={() => guard(() => api(`/api/admin/users/${r.id}/unban`, { method: "PUT" }).then(loadUsers))}>Unban</button>
                      <button className="danger" onClick={() => window.confirm(`Soft-delete user ${r.id}?`) && guard(() => api(`/api/admin/users/${r.id}`, { method: "DELETE" }).then(loadUsers))}>Delete</button>
                    </>
                  )}
                />
              </div>
            </div>
          )}

          {section === "pricing" && (
            <div className="section">
              <h2>Pricing</h2>
              <div className="glass card">
                <div className="row">
                  <div><label>Key</label>
                    <select ref={reg("pKey")}>
                      <option value="thunder_search">thunder_search</option>
                      <option value="featured_profile">featured_profile</option>
                      <option value="subscription">subscription</option>
                    </select>
                  </div>
                  <div><label>Amount (₹)</label><input ref={reg("pAmt")} type="number" step="1" /></div>
                  <div><label>Label</label><input ref={reg("pLbl")} placeholder="Thunder Search" /></div>
                  <button onClick={() => guard(setPrice)}>Save price</button>
                </div>
                <Table rows={pricing}
                  cols={[
                    { label: "Key", key: "key" },
                    { label: "Price", fn: (r) => "₹" + inr(r.amount / 100) },
                    { label: "Label", key: "label" },
                  ]} />
              </div>
            </div>
          )}

          {section === "coupons" && (
            <div className="section">
              <h2>Coupons</h2>
              <div className="glass card">
                <div className="row">
                  <div><label>Code</label><input ref={reg("cCode")} placeholder="DIWALI50" /></div>
                  <div><label>Type</label>
                    <select ref={reg("cType")}>
                      <option value="percent">percent</option>
                      <option value="flat">flat (₹)</option>
                    </select>
                  </div>
                  <div><label>Value</label><input ref={reg("cVal")} type="number" /></div>
                  <div><label>Max uses (0=∞)</label><input ref={reg("cMax")} type="number" defaultValue="0" /></div>
                  <button onClick={() => guard(createCoupon)}>Create coupon</button>
                </div>
                <Table rows={coupons}
                  cols={[
                    { label: "Code", key: "code" }, { label: "Type", key: "discount_type" },
                    { label: "Value", fn: (r) => r.discount_type === "flat" ? "₹" + r.value / 100 : r.value + "%" },
                    { label: "Used", fn: (r) => `${r.used_count}/${r.max_uses || "∞"}` },
                    { label: "Active", fn: (r) => r.is_active ? <Pill kind="ok">yes</Pill> : <Pill kind="bad">no</Pill> },
                  ]}
                  actions={(r) => (
                    <>
                      <button className="ghost" onClick={() => guard(() => api(`/api/admin/coupons/${r.id}/toggle`, { method: "PUT" }).then(loadCoupons))}>Toggle</button>
                      <button className="danger" onClick={() => guard(() => api(`/api/admin/coupons/${r.id}`, { method: "DELETE" }).then(loadCoupons))}>Delete</button>
                    </>
                  )}
                />
              </div>
              <div className="glass card">
                <h3>Redemption log</h3>
                <Table rows={couponLogs}
                  cols={[
                    { label: "ID", key: "redemption_id" }, { label: "Code", key: "coupon_code" },
                    { label: "Name", key: "name" }, { label: "Sex", key: "sex" }, { label: "Phone", key: "phone" },
                    { label: "Discount ₹", key: "discount_rupees" }, { label: "Discount %", key: "discount_percent" },
                    { label: "When", fn: (r) => dt(r.redeemed_at) },
                  ]} />
              </div>
            </div>
          )}

          {section === "referrals" && (
            <div className="section">
              <h2>Referral usage</h2>
              <div className="glass card">
                <Table rows={referrals}
                  cols={[
                    { label: "ID", key: "id" }, { label: "Referrer", key: "referrer" },
                    { label: "Code", key: "referrer_code" }, { label: "New user", key: "referred" },
                    { label: "Discount ₹", key: "discount_rupees" },
                    { label: "When", fn: (r) => dt(r.redeemed_at) },
                  ]} />
              </div>
            </div>
          )}

          {section === "revenue" && (
            <div className="section">
              <h2>Revenue</h2>
              <div className="tiles">
                {revenue &&
                  [
                    ["Today", revenue.today.total_rupees],
                    ["Last 7 days", revenue.last_7_days.total_rupees],
                    ["Last 30 days", revenue.last_30_days.total_rupees],
                    ["All time", revenue.all_time.total_rupees],
                  ].map(([l, n], i) => (
                    <div className="glass tile" key={i}>
                      <div className="num">₹{inr(n)}</div>
                      <div className="lbl">{l}</div>
                    </div>
                  ))}
              </div>
              <div className="glass card">
                <div className="row">
                  <div><label>Window (days)</label><input ref={reg("revDays")} type="number" defaultValue="7" /></div>
                  <div><label>Source</label>
                    <select ref={reg("revPurpose")}>
                      <option value="">All sources</option>
                      <option value="subscription">Subscription / registration</option>
                      <option value="thunder_search">Thunder Search</option>
                      <option value="featured_profile">Featured profile</option>
                    </select>
                  </div>
                  <button onClick={() => guard(loadRevenueFilter)}>Filter</button>
                </div>
                <div className="muted" style={{ marginTop: 12 }}>{revFilter}</div>
              </div>
              <div className="glass card">
                <h3>Source breakdown</h3>
                {revenue && (
                  <table>
                    <tbody>
                      <tr><th>Source (last 30 days)</th><th>Revenue</th></tr>
                      {Object.entries(revenue.last_30_days.by_source).map(([src, amt], i) => (
                        <tr key={i}><td>{src.replace("_", " ")}</td><td>₹{inr(amt)}</td></tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          )}

          {section === "market" && (
            <div className="section">
              <h2>Marketplace</h2>
              <div className="glass card">
                <h3>Categories</h3>
                <div className="row">
                  <input ref={reg("mcName")} placeholder="Category name (e.g. Marriage Hall)" />
                  <input ref={reg("mcIcon")} placeholder="Emoji (e.g. 🏛️)" style={{ maxWidth: 120 }} />
                  <input ref={reg("mcSort")} type="number" placeholder="Sort" defaultValue="0" style={{ maxWidth: 90 }} />
                  <button onClick={() => guard(addMarketCategory)}>Add category</button>
                </div>
                <Table rows={marketCats}
                  cols={[
                    { label: "Icon", key: "icon" }, { label: "Name", key: "name" },
                    { label: "Sort", key: "sort_order" },
                    { label: "Active", fn: (c) => (c.is_active ? "Yes" : "No") },
                  ]}
                  actions={(c) => <button className="danger" onClick={() => guard(() => delMarketCategory(c.id))}>Delete</button>}
                />
              </div>
              <div className="glass card">
                <h3>Businesses (max 5 per city + category)</h3>
                <div className="row">
                  <select ref={reg("mbCat")}>
                    {marketCats.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
                  </select>
                  <input ref={reg("mbCity")} placeholder="City (e.g. Belgaum)" />
                  <button onClick={() => guard(loadMarketBusinesses)}>View</button>
                </div>
                <hr />
                <div className="row"><b>Add a business</b></div>
                <div className="row">
                  <input ref={reg("bName")} placeholder="Business name" />
                  <input ref={reg("bPhone")} placeholder="Contact number" />
                  <input ref={reg("bEmail")} placeholder="Email" />
                </div>
                <div className="row">
                  <input ref={reg("bRating")} type="number" step="0.1" min="0" max="5" placeholder="Rating 0-5" />
                  <input ref={reg("bProjects")} type="number" placeholder="Total projects" />
                </div>
                <div className="row">
                  <input ref={reg("bLat")} placeholder="Latitude (e.g. 15.8497)" />
                  <input ref={reg("bLng")} placeholder="Longitude (e.g. 74.4977)" />
                </div>
                <div className="row"><input ref={reg("bAddr")} placeholder="Full address" style={{ width: "100%" }} /></div>
                <div className="row"><input ref={reg("bImg1")} placeholder="Image URL 1 (https://...jpg)" style={{ width: "100%" }} /></div>
                <div className="row"><input ref={reg("bImg2")} placeholder="Image URL 2" style={{ width: "100%" }} /></div>
                <div className="row"><input ref={reg("bImg3")} placeholder="Image URL 3" style={{ width: "100%" }} /></div>
                <div className="row"><button onClick={() => guard(addMarketBusiness)}>Add business</button></div>
                <Table rows={marketBiz}
                  cols={[
                    { label: "Name", key: "name" }, { label: "City", key: "city" },
                    { label: "Rating", key: "rating" }, { label: "Projects", key: "total_projects" },
                    { label: "Phone", key: "contact_number" },
                  ]}
                  actions={(b) => <button className="danger" onClick={() => guard(() => delMarketBusiness(b.id))}>Delete</button>}
                />
              </div>
            </div>
          )}

          {section === "keywords" && (
            <div className="section">
              <h2>Banned keywords</h2>
              <div className="glass card">
                <div className="row">
                  <div><label>Keyword</label><input ref={reg("kWord")} /></div>
                  <button onClick={() => guard(addKeyword)}>Add keyword</button>
                </div>
                <Table rows={keywords}
                  cols={[{ label: "ID", key: "id" }, { label: "Keyword", key: "keyword" }]}
                  actions={(r) => <button className="danger" onClick={() => guard(() => api(`/api/admin/keywords/${r.id}`, { method: "DELETE" }).then(loadKeywords))}>Delete</button>}
                />
              </div>
              <div className="glass card">
                <h3>Violations (3 strikes → 48 h auto-ban)</h3>
                <Table rows={violations}
                  cols={[
                    { label: "ID", key: "violation_id" }, { label: "User", key: "name" },
                    { label: "Message", key: "message" }, { label: "When", fn: (r) => dt(r.detected_at) },
                  ]} />
              </div>
            </div>
          )}

          {section === "banners" && (
            <div className="section">
              <h2>Home banners</h2>
              <div className="glass card">
                <div className="row">
                  <div><label>Image URL (or /uploads/… path)</label><input ref={reg("bImg")} /></div>
                  <div><label>Target URL</label><input ref={reg("bUrl")} /></div>
                  <div><label>Position</label><input ref={reg("bPos")} type="number" defaultValue="0" /></div>
                  <button onClick={() => guard(createBanner)}>Add banner</button>
                </div>
                <Table rows={banners}
                  cols={[
                    { label: "ID", key: "id" },
                    { label: "Image", fn: (r) => (
                      <img alt="" src={r.image_url.startsWith("http") ? r.image_url : (apiBase || "") + "/" + r.image_url}
                           style={{ height: 42, borderRadius: 8 }} />
                    ) },
                    { label: "Target", key: "target_url" }, { label: "Pos", key: "position" },
                    { label: "Active", fn: (r) => r.is_active ? <Pill kind="ok">yes</Pill> : <Pill kind="bad">no</Pill> },
                  ]}
                  actions={(r) => <button className="danger" onClick={() => guard(() => api(`/api/admin/banners/${r.id}`, { method: "DELETE" }).then(loadBanners))}>Delete</button>}
                />
              </div>
            </div>
          )}

          {section === "payments" && (
            <div className="section">
              <h2>Payments</h2>
              <div className="glass card">
                <Table rows={payments}
                  cols={[
                    { label: "Payment ID", key: "payment_id" }, { label: "User", key: "name" },
                    { label: "Purpose", key: "purpose" }, { label: "Amount ₹", key: "amount_rupees" },
                    { label: "Status", fn: (r) => <Pill kind={r.status === "success" ? "ok" : r.status === "failed" ? "bad" : "mid"}>{r.status}</Pill> },
                    { label: "Razorpay", key: "razorpay_payment_id" },
                    { label: "When", fn: (r) => dt(r.created_at) },
                  ]} />
              </div>
            </div>
          )}

          {section === "featured" && (
            <div className="section">
              <h2>Featured profiles</h2>
              <div className="glass card">
                <Table rows={featured}
                  cols={[
                    { label: "ID", key: "featured_id" }, { label: "User", key: "name" },
                    { label: "Starts", fn: (r) => dt(r.starts_at) }, { label: "Ends", fn: (r) => dt(r.ends_at) },
                    { label: "Active", fn: (r) => r.is_active ? <Pill kind="ok">live</Pill> : <Pill kind="bad">ended</Pill> },
                    { label: "Impressions", key: "impressions" },
                  ]} />
              </div>
            </div>
          )}

          {section === "rankings" && (
            <div className="section">
              <h2>Profile rankings</h2>
              <div className="glass card">
                <Table rows={rankings}
                  cols={[
                    { label: "User", key: "name" }, { label: "Score", key: "score" },
                    { label: "Breakdown", fn: (r) => <pre>{JSON.stringify(r.breakdown)}</pre> },
                  ]} />
              </div>
            </div>
          )}

          {section === "errors" && (
            <div className="section">
              <h2>App crashes &amp; errors</h2>
              <div className="glass card">
                <Table rows={errors}
                  cols={[
                    { label: "ID", key: "id" }, { label: "Platform", key: "platform" },
                    { label: "Version", key: "app_version" }, { label: "Screen", key: "screen_name" },
                    { label: "Type", key: "error_type" }, { label: "Message", key: "message" },
                    { label: "When", fn: (r) => dt(r.occurred_at) },
                  ]} />
              </div>
            </div>
          )}

          {section === "faqs" && (
            <div className="section">
              <h2>FAQs</h2>
              <div className="glass card">
                <div className="row">
                  <div><label>Question</label><input ref={reg("fQ")} /></div>
                  <div><label>Answer</label><input ref={reg("fA")} /></div>
                  <button onClick={() => guard(createFaq)}>Add FAQ</button>
                </div>
                <Table rows={faqs}
                  cols={[
                    { label: "ID", key: "id" }, { label: "Question", key: "question" }, { label: "Answer", key: "answer" },
                  ]}
                  actions={(r) => <button className="danger" onClick={() => guard(() => api(`/api/admin/faqs/${r.id}`, { method: "DELETE" }).then(loadFaqs))}>Delete</button>}
                />
              </div>
            </div>
          )}

          {section === "audit" && (
            <div className="section">
              <h2>Admin audit log</h2>
              <div className="glass card">
                <Table rows={audit}
                  cols={[
                    { label: "#", key: "id" }, { label: "Admin", key: "admin_id" },
                    { label: "Action", fn: (r) => <Pill kind="mid">{r.action}</Pill> },
                    { label: "Entity", fn: (r) => `${r.entity} #${r.entity_id ?? ""}` },
                    { label: "Details", fn: (r) => <pre>{JSON.stringify(r.details)}</pre> },
                    { label: "When", fn: (r) => dt(r.at) },
                  ]} />
              </div>
            </div>
          )}
        </main>
      </div>
    </div>
  );
}